import { createContext } from 'react';
import { useFiltersContext } from '../../../../../Dashboards/Common/Filters/hooks/useFiltersContext';
import { QUERY_KEYS_SIA, useChartsData } from '../../../../Common/hooks/useChartsData';

export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SIA.PRINCIPAL_CID,
            url: 'governanceroom/dashboard/services/stratify/cid'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value,
        }
    );

    const chartData = data?.counterByCID
        ? {
              counterByCID: data.counterByCID || [],
              ranking:
                  [
                      ...data.counterByCID.slice(0, 5),
                      {
                          type: 'Outros',
                          services: data.counterByCID
                              .slice(5)
                              .reduce(
                                  (acc, curr) => acc + Number(curr.services),
                                  0
                              ),
                          description: 'Outros'
                      }
                  ] || []
          }
        : {
              counterByCID: [],
              ranking: []
          };

    const subtitlesPrincipalCID = chartData.counterByCID.map((item) => item.type);

    const emptyIndicator =
        ((chartData.counterByCID.find(
            (indicator) => indicator.type === '0000'
        )?.services ?? 0) /
            chartData.counterByCID.reduce(
                (acc, curr) => acc + Number(curr.services),
                0
            )) *
        100;

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                subtitlesPrincipalCID,
                isLoading,
                isError,
                filters,
                module,
                emptyIndicator,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
